import axios from 'axios';
import { API_PATHS } from './constants';
import { IErrorObject, IErrorResponse } from './contracts';
import { clientConfig, RemoveAllLoggedInUsersData } from './utils';

export const baseURL = `${clientConfig.apiBaseUrl}/api/v2`

export const axiosInstance = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});


axiosInstance.interceptors.request.use(
  (config: any) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['x-auth-token'] = token;
    }
    const org = localStorage.getItem('organizationId');
    if (org) {
      config.headers['x-organization-id'] = org.toString();
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


axiosInstance.interceptors.response.use(
  (response: any) => {
    return response;
  },
  async (error: any) => {
    const errorObj: IErrorResponse = {};
    errorObj.actualError = error;

    if (error?.response?.data?.message === 'MAINTENANCE_MODE' ) {
      if (window.location.pathname !== '/maintenance') {
        window.location.href = '/maintenance';
      }
      return Promise.reject(errorObj);
    }

    if(error?.response?.data?.message === 'ACCESS_DENIED'){
      try {
        const refreshToken = localStorage.getItem('refreshToken');
        if (!refreshToken) {
          RemoveAllLoggedInUsersData();
          window.location.href = '/login';
          return Promise.reject(errorObj);
        }

        const response = await axiosInstance.post(API_PATHS.REFRESH_TOKEN, {
          refreshToken
        });

        const { token, refreshToken: newRefreshToken } = response.data;
        
        localStorage.setItem('token', token);
        localStorage.setItem('refreshToken', newRefreshToken);
        
        error.config.headers['x-auth-token'] = token;
        return axiosInstance(error.config);
      } catch (refreshError) {
        RemoveAllLoggedInUsersData();
        window.location.href = '/login';
        return Promise.reject(errorObj);
      }
    }
    
    if(error?.response?.data?.message === 'ACCESS_ORGANIZATION_DENIED'){
      RemoveAllLoggedInUsersData();
      window.location.href = '/login';
    }

    if (error?.response?.data) {
      errorObj.ServerErrorCode = [];
      Object.keys(error.response.data).map((key) => {
        errorObj?.ServerErrorCode?.push({
          field: key,
          code: error.response.data[key],
        } as IErrorObject);
      });
    } else {
      errorObj.GeneralErrorCode = 'GENERAL_ERROR';
    }

    return Promise.reject(errorObj);
  }
);


